<template>
  <modal :show="show" @hide="hideModal" id="sgz-modal">
    <template slot="btn">
      <img
        src="/fonts/icons/sgz-close-btn.svg"
        id="sgz-modal-close-btn"
        width="20"
        height="20"
      />
    </template>
    <div id="popup-wrapper">
      <form @submit.prevent="subscribe" v-if="!subscribed">
        <grid flat vertical="middle">
          <grid-item size="9/12">
            <input
              type="email"
              name="email"
              placeholder="ENTER YOUR E-MAIL HERE"
              v-validate="'required|email'"
              v-model="form.email"
              style="display: block"
              id="sgz-submit-input"
            />
          </grid-item>
          <grid-item size="3/12">
            <button
              type="submit"
              :disabled="errors && errors.items && errors.items.length > 0"
              id="sgz-submit-button"
            >
              SUBMIT
            </button>
          </grid-item>
        </grid>
        <div style="color: #d69595">{{ errors.first("email") }}</div>
        <div style="margin: 2em 0" class="text-center">
          <label id="gdpr">
            <img
              :src="
                form.legal
                  ? '/fonts/icons/checkbox_ok.svg'
                  : '/fonts/icons/checkbox.svg'
              "
              width="40"
              height="40"
            />
            &nbsp;&nbsp;
            <input
              v-model="form.legal"
              name="gdpr"
              v-validate="'required'"
              hidden
              type="checkbox"
            />
            I agree with
            <a
              href="https://www.bohemia.net/privacy-policy"
              target="_blank"
              style="text-decoration: underline"
              >GDPR/processing</a
            >
          </label>
          <div style="color: #d69595">{{ errors.first("gdpr") }}</div>
        </div>
        <requirements />
      </form>
      <p v-if="subscribed">
        Thank you for the request!
        <br />
        Access codes will be distributed gradually, based on the request time
        and date.
      </p>
    </div>
  </modal>
</template>

<script>
import Requirements from "./Requirements";
import Modal from "@/components/common/Modal";
import EventBus from "@/EventBus";
import { MailtrainResource } from "@/services";

export default {
  name: "SgzFormPopup",
  data() {
    return {
      show: false,
      loading: false,
      subscribed: false,
      form: {
        email: null,
        legal: false
      }
    };
  },
  components: {
    Requirements,
    Modal
  },
  methods: {
    hideModal() {
      this.show = false;
    },
    async subscribe() {
      try {
        const valid = await this.$validator.validate();

        if (valid) {
          this.loading = true;
          await MailtrainResource.subscribe(this.form);
          this.subscribed = true;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    EventBus.$on("toggle-popup", value => {
      this.show = value;
    });
  }
};
</script>

<style lang="scss">
#sgz-modal {
  .cu-modal-dialog {
    background: none;
    width: 100%;
    max-width: 700px;

    @media (max-width: 600px) {
      height: 100%;
    }
  }

  .cu-modal-close {
    background: none;
    top: 20px;
    right: 20px;
  }
}
</style>

<style lang="scss" scoped>
#popup-wrapper {
  padding: 4em;
  border-radius: 18px;
  overflow: hidden;
  width: 100%;
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.74) 0%,
    #000000 16%,
    #292929 100%
  );

  @media (max-width: 600px) {
    height: 100%;
    border-radius: 0;
    padding: 3em 1em 3em;
  }
}

#sgz-submit-input,
#sgz-submit-button {
  width: 100%;
  outline: 0;
}

#sgz-modal-close-btn {
  @media (max-width: 600px) {
    width: 15px;
    height: 15px;
  }
}

#sgz-submit-input {
  border: 2px solid #e9d445;
  border-radius: 11px 0 0 11px;
  line-height: 3.45em;
  padding: 0 1em;
  background-color: #4d4d4d;
  color: #fff;

  @media (max-width: 500px) {
    line-height: 2.45em;
  }
}

::placeholder,
:-ms-input-placeholder,
::-ms-input-placeholder,
::-webkit-input-placeholder {
  color: #fff;
}

#sgz-submit-button {
  border: 2px solid #e9d445;
  background-color: #e9d445;
  border-radius: 0 10px 10px 0;
  color: #000;
  font-size: 14px;
  font-family: "Metron Book";
  letter-spacing: 1.65px;
  line-height: 3.95em;
  padding: 0;
  outline: 0;

  @media (max-width: 500px) {
    line-height: 3em;
    font-size: 13px;
  }
}
</style>
